import axios from '@axios'

export default {
  generate(data) {
    return axios.post('/profissional/atendimento/paciente_exames', data)
  },
  getById(id) {
    return axios.get(`/profissional/atendimento/paciente_exames/${id}`)
  },
  getPatientById(id) {
    return axios.get(
      `/profissional/atendimento/paciente_exames/paciente/${id}`,
    )
  },
  updateExame(data) {
    return axios.put(
      '/profissional/atendimento/paciente_exames/resultado',
      data,
    )
  },
  addExames(data) {
    return axios.post(
      `/profissional/atendimento/paciente_exames/adicionar_exame/${data.id}`,
      data.exames,
    )
  },
  combosExames() {
    return axios.get('/profissional/atendimento/paciente_exames/lista_exame')
  },
  delete(id) {
    return axios.delete(
      `/profissional/atendimento/paciente_exames/remover_exame/${id}`,
    )
  },
  editObservacao(data) {
    return axios.put(
      `/profissional/atendimento/paciente_exames/observacao/${data.id}`,
      data.observacao,
    )
  },
}
